var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlackBaudIcon = function SvgBlackBaudIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BlackBaudIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54.932 2.059c.305.174.558.428.73.735.177.324.267.689.262 1.058.005.37-.085.734-.262 1.058-.172.307-.425.56-.73.735a2.24 2.24 0 0 1-2.117 0 1.921 1.921 0 0 1-.734-.735 2.112 2.112 0 0 1-.28-1.058c-.006-.37.086-.735.266-1.058.173-.308.427-.562.735-.735a2.24 2.24 0 0 1 2.117 0h.013Zm.16 3.041a1.71 1.71 0 0 0 .473-1.248 1.722 1.722 0 0 0-.474-1.253 1.656 1.656 0 0 0-1.23-.478 1.674 1.674 0 0 0-1.24.474 1.699 1.699 0 0 0-.474 1.257 1.691 1.691 0 0 0 .474 1.253 1.66 1.66 0 0 0 1.24.478 1.642 1.642 0 0 0 1.23-.483Zm-.594-1.328a.65.65 0 0 1-.376.217l.597.855h-.39l-.553-.815h-.203v.806h-.328v-2.09h.589a.956.956 0 0 1 .61.168.567.567 0 0 1 .204.443.624.624 0 0 1-.128.39l-.022.026Zm-.925-.026h.243c.337 0 .505-.124.505-.368 0-.243-.168-.345-.505-.345h-.243v.713Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#BlackBaudIcon_svg__b)",
    d: "M.885 28.978a28.092 28.092 0 1 0 56.184 0 28.092 28.092 0 0 0-56.184 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.118 32.493c0-1.594-1.86-4.387-1.86-4.387-.443-.665-.212-.886.478-.479l6.89 4.335c.69.443.69.611 0 1.036l-6.89 4.361c-.69.443-.885.186-.478-.478 1.86-2.794 1.86-4.388 1.86-4.388ZM25.28 42.026c6.101 0 9.9-4.397 9.896-9.497 0-5.287-3.706-9.74-9.989-9.502-1.77.071-3.325.917-4.511 1.718v-8.77h-3.649v20.724s2.148 5.313 8.249 5.313l.004.014Zm-4.604-6.163V29.22a6.549 6.549 0 0 1 4.188-2.568c4.224-.53 6.805 2.838 6.805 5.969a6.024 6.024 0 0 1-6.69 5.844 6.397 6.397 0 0 1-4.303-2.603Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "BlackBaudIcon_svg__b",
    x1: 11.069,
    x2: 53.572,
    y1: 49.588,
    y2: 5.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "BlackBaudIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgBlackBaudIcon;